import React from "react";
import Title from "../Title/Title";
import "./Message.css";
import { ReactComponent as DoneSVG } from "../../images/done-icon.svg";
import { ReactComponent as MailSVG } from "../../images/mailopen-icon.svg";
import { Link } from "react-router-dom";

const Message = () => {
  return (
    <>
      <div className="mb-5"></div>
      <div className="message-section">
        <div className="msg-box-1">
          <div className="back-btn">
            <Link to="/">
              <button className="backtohome">&#60; Back to Home</button>
            </Link>
          </div>
          <Title title="Thanks for your message" />
          <Title title="I will contact you soon" />
          <Title title="Have a great day ahead and take care !!!" />
        </div>

        <div className="msg-box-2">
          <div className="success-message-box">
            <DoneSVG className="msg-svg" />
            <MailSVG className="msg-svg" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Message;
